import { useRouter } from 'next/router'
import useTranslation from 'next-translate/useTranslation'

function ScrollInto() {
  const { t } = useTranslation('global')
  const router = useRouter()

  const handleScroll = (scrollTo: string): void => {
    const element = document.getElementById(scrollTo)
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' })
    }
  }

  return (
    <div className="items-center justify-center hidden w-full mb-6 space-x-4 lg:flex">
      <button onClick={() => handleScroll('benefits')}>
        <span className="text-gray-100 hover:text-gray-150">
          {t('well_being_mobile_navigation_1')}
        </span>
      </button>
      <Dot />
      <button onClick={() => handleScroll('rules')}>
        <span className="text-gray-100 hover:text-gray-150">
          {t('well_being_mobile_navigation_2')}
        </span>
      </button>
      <Dot />
      <button onClick={() => handleScroll('contact')}>
        <span className="text-gray-100 hover:text-gray-150">
          {t('well_being_mobile_navigation_3')}
        </span>
      </button>
      <Dot />
      <button onClick={() => router.push('/')}>
        <span className="text-gray-100 hover:text-gray-150">
          {t('well_being_mobile_navigation_4')}
        </span>
      </button>
    </div>
  )
}

function Dot() {
  return (
    <div className="flex items-center justify-center">
      <span>·</span>
    </div>
  )
}

export default ScrollInto
